import { cn } from "@/utils";
import { InputHTMLAttributes, ReactNode } from "react";

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string | null;
  icon?: ReactNode;
}

export default function Field({
  label,
  error,
  icon,
  className,
  id,
  ...props
}: FieldProps) {
  const inputId = id || label.replace(/\s+/g, "-").toLowerCase();

  return (
    <div className={cn("flex w-full flex-col gap-1.5", className)}>
      <label htmlFor={inputId} className="text-[11px] uppercase tracking-[0.16em] text-checkout-muted">
        {label}
      </label>
      <div className="checkout-field">
        <input id={inputId} placeholder=" " {...props} />
        {icon && <span className="text-checkout-muted">{icon}</span>}
      </div>
      {error && <span className="text-left text-sm text-[#f07167]">{error}</span>}
    </div>
  );
}
